// Copied from ui/src/components/assets/ATFLogo.tsx (Genesis brand
// conformance pass) — the real ATF Pyramid mark, gold stroke on dark,
// outlined never filled (Genesis "Logo Rules"). Adapted only to use this
// app's trivial cn() instead of the reference app's clsx-backed one.
import { cn } from '@/lib/utils/cn'

export interface ATFLogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'icon' | 'full' | 'text'
  style?: React.CSSProperties
}

export function ATFLogo({ className, size = 'md', variant = 'icon', style }: ATFLogoProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
  }

  const LogoIcon = () => (
    <svg
      className={cn(sizeClasses[size], className)}
      viewBox="0 0 698 599"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M353.605 20.9766L682.061 583.896L687.326 592.92H10.5693L15.8135 583.902L343.236 20.9834L348.415 12.0801L353.605 20.9766ZM360.931 568.92H645.536L573.475 445.42H360.931V568.92ZM52.293 568.92H336.931V302.42H207.303L52.293 568.92ZM360.931 421.42H559.473L490.036 302.42H360.931V421.42ZM221.263 278.42H476.034L348.447 59.7578L221.263 278.42Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="12"
      />
    </svg>
  )

  if (variant === 'full') {
    return (
      <div className={cn('flex items-center gap-3', className)}>
        <LogoIcon />
        <div className="flex flex-col">
          <span className="font-display font-semibold text-[0.82rem] tracking-[0.14em] uppercase leading-none">ATF</span>
          <span className="font-display text-xs tracking-[0.08em] opacity-75">Agent Taskflow</span>
        </div>
      </div>
    )
  }

  if (variant === 'text') {
    return (
      <div className={cn('flex items-center gap-2', className)}>
        <LogoIcon />
        <div className="flex flex-col leading-none">
          <span className="font-display font-semibold text-[0.82rem] tracking-[0.14em] uppercase">Agent</span>
          <span className="font-display font-medium text-[0.65rem] tracking-[0.10em] uppercase opacity-70">Taskflow</span>
        </div>
      </div>
    )
  }

  return <LogoIcon />
}
